const STORAGE_PREFIX = 'votiq_widget_session_';

export function widgetSessionStorageKey(projectId: string): string {
    return `${STORAGE_PREFIX}${projectId}`;
}

export function readWidgetSessionToken(projectId: string): string | null {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }

    try {
        return sessionStorage.getItem(widgetSessionStorageKey(projectId));
    } catch {
        return null;
    }
}

export function writeWidgetSessionToken(
    projectId: string,
    token: string,
): void {
    if (typeof sessionStorage === 'undefined') {
        return;
    }

    try {
        sessionStorage.setItem(widgetSessionStorageKey(projectId), token);
    } catch {
        // Ignore quota / private mode errors.
    }
}

export function clearWidgetSessionToken(projectId: string): void {
    if (typeof sessionStorage === 'undefined') {
        return;
    }

    try {
        sessionStorage.removeItem(widgetSessionStorageKey(projectId));
    } catch {
        // Ignore.
    }
}

function visitorEmailStorageKey(projectId: string): string {
    return `votiq_widget_email_${projectId}`;
}

export function readWidgetVisitorEmail(projectId: string): string | null {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }

    try {
        return sessionStorage.getItem(visitorEmailStorageKey(projectId));
    } catch {
        return null;
    }
}

export function writeWidgetVisitorEmail(
    projectId: string,
    email: string,
): void {
    if (typeof sessionStorage === 'undefined') {
        return;
    }

    try {
        sessionStorage.setItem(
            visitorEmailStorageKey(projectId),
            email.trim().toLowerCase(),
        );
    } catch {
        // Ignore.
    }
}
